import styles from "components/_other/form/TextInput.module.scss";
import LoadingIcon from '@/components/_other/icons/LoadingIcon';

const TextInput = ({
  label,
  small = false,
  required = false,
  error = "",
  hasFeedback = true,
  inputProps = {},
  hint = "",
  isLoading = false,
  before = null,
  after = null
}) => {
  const {
    id,
    name,
    type = "text",
    value = "",
    className: inputClassName = "",
    groupClassName = "",
    readOnly,
    disabled,
    ...restInputProps
  } = inputProps;
  const isSuccess = value && !error;
  const inputId = id || name;
  return (
    <div
      className={`
        ${groupClassName}
        ${styles.inputGroup} 
        ${isLoading ? styles?.loading : ""}
        ${error ? styles?.error : ""} 
        ${hasFeedback && isSuccess ? styles?.success : ""}
    `}
    >
      {label ? (
        <label htmlFor={inputId}>
          {label} {required ? "*" : ""}
        </label>
      ) : null}



      <div className="relative w-full">
        {isLoading ? (
          <div className="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none w-[30px]">
            <LoadingIcon />
          </div>
        ) : null}
        {before || null}
        <input
          id={inputId}
          type={type}
          value={value}
          name={name}
          className={`${small ? styles?.small : ""} ${inputClassName}`}
          readOnly={readOnly}
          disabled={disabled}
          {...restInputProps}
        />
        {after || null}
      </div>
      {hint ? <div className={`${styles?.hint} form-text`}>{hint}</div> : null}
      {error ? <span>{error}</span> : null}
    </div>
  );
};

export default TextInput;
